import { Component } from '@angular/core';
import {UtilityService} from "./utility.service";

declare const particlesJS: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [],
})
export class AppComponent {

  ngOnInit() {
    particlesJS.load('particles-js', 'assets/particles.config.json', null);
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/app.component.ts